import { useState, useEffect } from "react";

import { translate } from "app/filters/i18nFilter";
import AnimatedGradientText from "app/pages/sales-intelligence/modules/ai-agent/components/AnimatedGradientText/AnimatedGradientText";

const REASONING_TEXT_KEYS = [
    "si.pages.ai_agent.reasoning_stage.text1",
    "si.pages.ai_agent.reasoning_stage.text2",
    "si.pages.ai_agent.reasoning_stage.text3",
    "si.pages.ai_agent.reasoning_stage.text4",
    "si.pages.ai_agent.reasoning_stage.text5",
];

type Props = {
    textKeys?: string[];
};

const AIAgentReasoning = ({ textKeys = REASONING_TEXT_KEYS }: Props) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % textKeys.length);
        }, 2000);
        return () => clearInterval(interval);
    }, [textKeys]);

    return <AnimatedGradientText text={translate(textKeys[currentIndex])} />;
};

export default AIAgentReasoning;
